import { createContext } from 'react'

export type Locale = 'tr' | 'en'

type MessageValue = string | number | boolean | null

export type TranslationParams = Record<string, MessageValue>

export interface I18nContextValue {
  locale: Locale
  setLocale: (next: Locale) => void
  t: (key: string, fallback?: string, params?: TranslationParams) => string
}

export const I18nContext = createContext<I18nContextValue | undefined>(undefined)
